import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-event-block',
  templateUrl: './event-block.component.html',
  styleUrls: ['./event-block.component.scss']
})
export class EventBlock {
  @Input() data: any;

  breakpoints = {
    0: {
      slidesPerView: 'auto',
      centeredSlides: true,
      spaceBetween: 16
    },
    768: {
      slidesPerView: 1,
      centeredSlides: false,
      spaceBetween: 50
    }
  };
}
